"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverflowSet = void 0;
var Utilities_1 = require("../../Utilities");
var OverflowSet_base_1 = require("./OverflowSet.base");
var OverflowSet_styles_1 = require("./OverflowSet.styles");
exports.OverflowSet = (0, Utilities_1.styled)(OverflowSet_base_1.OverflowSetBase, OverflowSet_styles_1.getStyles, undefined, {
    scope: 'OverflowSet',
});
//# sourceMappingURL=OverflowSet.js.map